(function () {
  'use strict';

  // ── Engraving preview color configuration ─────────────────
  // Modifica estos valores para ajustar el gris del grabado en el preview

  // Grises según el tono del producto:
  //   darkProduct  → termo de color oscuro (negro, azul marino, etc.)
  //   lightProduct → termo de color claro  (solo Blanco por ahora)
  //   fallback     → color no clasificado → se trata como oscuro
  var ENGRAVING_PREVIEW_GRAYS = {
    darkProduct:  '#BFC3C5',
    lightProduct: '#6F7478',
    fallback:     '#BFC3C5'
  };

  // Clasificación de cada color: 'dark' o 'light'
  // Solo Blanco usa grabado en gris oscuro; todo lo demás queda como oscuro (via fallback)
  var PRODUCT_COLOR_TONE_MAP = {
    'Blanco': 'light'
  };

  // Override por color específico — tiene prioridad sobre el mapa anterior
  // Para asignar un gris exacto a un color, descomenta y ajusta:
  var PRODUCT_COLOR_GRAY_OVERRIDES = {
    // 'Blanco': '#5F6468',
    // 'Negro':  '#C9CDD0'
  };

  var MAX_LINE_CHARS = 24;
  var MAX_WORD_CHARS = 15;
  var SHARE_TEXT     = '¡Mira el diseño que armé para mi termo personalizado! 🔥✨';

  // ── State ──────────────────────────────────────────
  let selectedModel   = null;
  let selectedColor   = null;
  let selectedVariant = null;
  let designScalePct = 75;
  let textPosition = 'abajo';
  let textScale    = 100;
  let selectedFont = 'Glacial Indifference';

  const fontFamilyMap = {
    'Glacial Indifference': { family: "'Glacial Indifference', sans-serif", weight: '400' },
    'EB Garamond':          { family: "'EB Garamond', serif",               weight: '600' },
    'Pacifico':             { family: "'Pacifico', cursive",                weight: '400' },
    'Dancing Script':       { family: "'Dancing Script', cursive",          weight: '700' },
    'Lobster':              { family: "'Lobster', cursive",                 weight: '400' },
    'Nunito':               { family: "'Nunito', sans-serif",               weight: '700' },
    'Sackers Gothic':       { family: "'Sackers Gothic', sans-serif",       weight: '400' }
  };

  let modelOptionIdx  = -1;
  let colorOptionIdx  = -1;
  let confirmed       = false;
  let buyNow          = false;
  let shareToast      = null;
  let shareToastTimer = null;

  // ── DOM ────────────────────────────────────────────
  const productImg   = document.getElementById('pv2-product-img');
  const previewBox   = document.getElementById('pv2-preview');
  const engraveZone  = document.getElementById('pv2-engrave-zone');
  const textLayer    = document.getElementById('pv2-text-layer');
  const textPreview  = document.getElementById('pv2-text-preview');
  const variantInput = document.getElementById('pv2-variant-id');
  const propText      = document.getElementById('pv2-prop-text');
  const propFont      = document.getElementById('pv2-prop-font');
  const propSize      = document.getElementById('pv2-prop-size');
  const propTextPos   = document.getElementById('pv2-prop-textpos');
  const propTextScale = document.getElementById('pv2-prop-textscale');
  const propLink      = document.getElementById('pv2-prop-link');
  const propTplVer    = document.getElementById('pv2-prop-tplver');
  const textInput    = document.getElementById('pv2-text-input');
  const charNum      = document.getElementById('pv2-char-num');
  const textControls = document.getElementById('pv2-text-controls');
  const addBtn        = document.getElementById('pv2-add-btn');
  const form          = document.getElementById('pv2-form');
  const zoomBtn       = document.getElementById('pv2-zoom-btn');
  const zoomModal     = document.getElementById('pv2-zoom-modal');
  const zoomContainer = document.getElementById('pv2-zoom-container');
  const zoomClose     = document.getElementById('pv2-zoom-close');
  const zoomBackdrop  = document.getElementById('pv2-zoom-backdrop');

  // ── Data from Liquid ───────────────────────────────
  const config         = window.ppV2Config         || { designSvg: '', models: {} };
  const variants       = window.ppVariants         || [];
  const variantImages  = window.ppV2VariantImages  || {};
  const variantPrices  = window.ppV2VariantPrices  || {};

  // ── Helpers ────────────────────────────────────────
  function getOption(variant, idx) {
    if (idx < 0 || !variant) return null;
    return variant['option' + (idx + 1)];
  }

  function findVariant(model, color) {
    return variants.find(function (v) {
      return getOption(v, modelOptionIdx) === model &&
             getOption(v, colorOptionIdx) === color;
    }) || null;
  }

  function colorsForModel(model) {
    var seen = [];
    variants.forEach(function (v) {
      if (getOption(v, modelOptionIdx) === model) {
        var c = getOption(v, colorOptionIdx);
        if (c && seen.indexOf(c) === -1) seen.push(c);
      }
    });
    return seen;
  }

  // ── Accordion helpers ──────────────────────────────
  function accSetValue(id, text) {
    var el = document.getElementById(id);
    if (el) el.textContent = text;
  }

  function openAccordion(key) {
    document.querySelectorAll('.pv2-acc__trigger').forEach(function (t) {
      var isTarget = t.dataset.acc === key;
      t.classList.toggle('pv2-acc__trigger--open', isTarget);
      var body = t.parentElement.querySelector('.pv2-acc__body');
      if (body) body.style.display = isTarget ? '' : 'none';
    });
  }

  function closeAllAccordions() {
    document.querySelectorAll('.pv2-acc__trigger').forEach(function (t) {
      t.classList.remove('pv2-acc__trigger--open');
      var body = t.parentElement.querySelector('.pv2-acc__body');
      if (body) body.style.display = 'none';
    });
  }

  function updateModelColorValue() {
    accSetValue('pv2-acc-model-val', selectedModel || '');
    accSetValue('pv2-acc-color-val', selectedColor || '');
  }

  // ── Engraving color helpers ────────────────────────
  function getEngravingGray(colorName) {
    if (colorName && PRODUCT_COLOR_GRAY_OVERRIDES[colorName]) {
      return PRODUCT_COLOR_GRAY_OVERRIDES[colorName];
    }
    var tone = colorName && PRODUCT_COLOR_TONE_MAP[colorName];
    if (tone === 'dark')  return ENGRAVING_PREVIEW_GRAYS.darkProduct;
    if (tone === 'light') return ENGRAVING_PREVIEW_GRAYS.lightProduct;
    return ENGRAVING_PREVIEW_GRAYS.fallback;
  }

  function hexToInvertFilter(hex) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    var pct = Math.round((r + g + b) / 3 / 255 * 100);
    return 'invert(' + pct + '%)';
  }

  function applyEngravingColor(colorName) {
    var gray = getEngravingGray(colorName);
    var designImg = document.getElementById('pv2-design-img');
    if (designImg) designImg.style.filter = hexToInvertFilter(gray);
    if (textPreview) textPreview.style.color = gray;

    // Modo metálico: si el color del termo es 'light', oscurecer la textura
    if (previewBox) {
      var tone = colorName && PRODUCT_COLOR_TONE_MAP[colorName];
      previewBox.classList.toggle('pv2-preview--metallic-light', tone === 'light');
    }
  }

  // Aplica textura + máscara SVG en inline-style al overlay metálico.
  // El SVG se convierte a data: URL (vía fetch + base64) para evitar el problema
  // de CORS-mask: si el SVG no es accesible como mask cross-origin, el elemento
  // queda invisible. La data URL bypassea esa restricción.
  async function applyMetallicMask() {
    if (!previewBox) return;
    var textureUrl = previewBox.dataset.textureUrl || '';
    if (!textureUrl) return;
    var texCss = 'url("' + textureUrl + '")';

    var designImg   = document.getElementById('pv2-design-img');
    var designMetal = document.getElementById('pv2-design-metal');

    if (textPreview) {
      textPreview.style.backgroundImage = texCss;
    }

    if (!designMetal || !designImg || !designImg.src) return;

    // Background del metal div: la textura
    designMetal.style.backgroundImage = texCss;

    // Máscara: convertir SVG a data URL para evitar restricciones CORS de mask-image
    var maskUrl = designImg.src;
    try {
      var response = await fetch(designImg.src);
      if (response.ok) {
        var svgText = await response.text();
        // btoa solo soporta ASCII; convertir unicode primero
        var b64 = btoa(unescape(encodeURIComponent(svgText)));
        maskUrl = 'data:image/svg+xml;base64,' + b64;
      }
    } catch (e) {
      // Fallback: usar la URL directa (puede o no funcionar dependiendo del browser)
      console.warn('[pv2] No se pudo convertir SVG a data URL, usando URL directa:', e);
    }
    var maskCss = 'url("' + maskUrl + '")';
    designMetal.style.webkitMaskImage = maskCss;
    designMetal.style.maskImage       = maskCss;
  }

  // Toggle de clase para activar/desactivar clip-text en el texto.
  // El clip-text se aplica solo cuando hay texto Y el modo metálico está activo.
  function updateTextMetallic() {
    if (!textPreview || !previewBox) return;
    var isMetallic = previewBox.classList.contains('pv2-preview--metallic');
    var hasText    = textInput && textInput.value.length > 0;
    textPreview.classList.toggle('pv2-text-preview--metal-active', isMetallic && hasText);
  }

  // ── Engrave zone ───────────────────────────────────
  function applyModelConfig(modelName) {
    var cfg = config.models[modelName];
    if (!cfg || !engraveZone || !productImg || !previewBox) return;

    var imgRect = productImg.getBoundingClientRect();
    var boxRect = previewBox.getBoundingClientRect();

    if (imgRect.width > 0 && imgRect.height > 0) {
      var offsetLeft = imgRect.left - boxRect.left;
      var offsetTop  = imgRect.top  - boxRect.top;
      var zoneW = imgRect.width  * cfg.areaWidth  / 100;
      var zoneH = imgRect.height * cfg.areaHeight / 100;
      var zoneL = offsetLeft + (imgRect.width - zoneW) / 2;
      var zoneT = offsetTop  + imgRect.height * cfg.areaTop / 100;
      engraveZone.style.left      = zoneL + 'px';
      engraveZone.style.top       = zoneT + 'px';
      engraveZone.style.width     = zoneW + 'px';
      engraveZone.style.height    = zoneH + 'px';
      engraveZone.style.transform = 'none';

      // Grosor de la línea punteada proporcional al tamaño de la zona, para que
      // se vea con el mismo peso visual en mobile y desktop.
      var outlineW = Math.max(1, zoneW * 0.013);
      engraveZone.style.outlineWidth  = outlineW + 'px';
      engraveZone.style.outlineOffset = (-outlineW / 2) + 'px';
    } else {
      engraveZone.style.left      = '50%';
      engraveZone.style.top       = cfg.areaTop    + '%';
      engraveZone.style.width     = cfg.areaWidth  + '%';
      engraveZone.style.height    = cfg.areaHeight + '%';
      engraveZone.style.transform = 'translateX(-50%)';
    }
  }

  function refreshZone() {
    if (selectedModel) {
      applyModelConfig(selectedModel);
      applyDesignScale();
      updateLayout();
    }
  }

  // ── Mobile: encoger preview en scroll ──────────────
  // Inicio: 55vh (preview grande). Final: 24vh (sticky chico). Interpolación lineal
  // según scrollY en el rango [0, SHRINK_RANGE_PX]. Solo aplica en mobile (<=749px).
  var SHRINK_INIT_VH  = 55;
  var SHRINK_END_VH   = 24;
  var SHRINK_RANGE_PX = 220;

  function isMobileView() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function updateShrinkOnScroll() {
    if (!previewBox) return;
    if (!isMobileView()) {
      previewBox.style.removeProperty('height');
      previewBox.style.removeProperty('max-height');
      return;
    }
    var scrollY  = window.scrollY || window.pageYOffset || 0;
    var progress = Math.max(0, Math.min(1, scrollY / SHRINK_RANGE_PX));
    var currentVh = SHRINK_INIT_VH - (SHRINK_INIT_VH - SHRINK_END_VH) * progress;
    previewBox.style.setProperty('height',     currentVh + 'vh', 'important');
    previewBox.style.setProperty('max-height', currentVh + 'vh', 'important');

    // Re-layout zone de grabado y diseño/texto con el nuevo tamaño
    if (selectedModel) {
      applyModelConfig(selectedModel);
      var hasText = textInput && textInput.value.length > 0;
      if (hasText) updateLayout();
    }
  }

  var _shrinkRaf = false;
  function _onShrinkTrigger() {
    if (_shrinkRaf) return;
    _shrinkRaf = true;
    requestAnimationFrame(function () {
      updateShrinkOnScroll();
      _shrinkRaf = false;
    });
  }

  function initShrinkOnScroll() {
    window.addEventListener('scroll', _onShrinkTrigger, { passive: true });
    window.addEventListener('resize', _onShrinkTrigger);
    updateShrinkOnScroll();
  }

  // ── Zoom ───────────────────────────────────────────
  function buildZoomPreview(container) {
    container.innerHTML = '';
    var preview = previewBox;
    var zone    = engraveZone;
    if (!preview || !zone || !preview.offsetWidth) return;

    var pr = preview.getBoundingClientRect();
    var zr = zone.getBoundingClientRect();
    var mx = zr.width  * 0.35;
    var my = zr.height * 0.35;
    var maxW  = Math.min(window.innerWidth  * 0.72, 440);
    var maxH  = Math.min(window.innerHeight * 0.55, 420);
    var scale = Math.min(maxW / (zr.width + 2 * mx), maxH / (zr.height + 2 * my));
    var containerW = Math.round((zr.width  + 2 * mx) * scale);
    var containerH = Math.round((zr.height + 2 * my) * scale);
    var cropRelLeft = (zr.left - pr.left) - mx;
    var cropRelTop  = (zr.top  - pr.top)  - my;

    var outer = document.createElement('div');
    outer.style.cssText = 'position:relative;width:' + containerW + 'px;height:' + containerH + 'px;overflow:hidden;border-radius:0.8rem;margin:0 auto;';

    var clone = preview.cloneNode(true);
    clone.style.cssText = 'position:absolute;top:' + (-cropRelTop * scale) + 'px;left:' + (-cropRelLeft * scale) + 'px;transform:scale(' + scale + ');transform-origin:0 0;pointer-events:none;';
    // width/height con !important: en móvil el stylesheet fuerza height:55vh
    // !important sobre .pv2-preview; sin esto el clon se renderiza con otra
    // altura distinta a la medida (pr) y el recorte queda desfasado.
    clone.style.setProperty('width',  pr.width  + 'px', 'important');
    clone.style.setProperty('height', pr.height + 'px', 'important');
    clone.style.setProperty('overflow', 'visible', 'important');
    clone.style.setProperty('max-height', 'none', 'important');

    var cloneZoomBtn = clone.querySelector('.pv2-zoom-btn');
    if (cloneZoomBtn) cloneZoomBtn.style.display = 'none';

    outer.appendChild(clone);
    container.appendChild(outer);
  }

  // Bloquear scroll SIN mover el layout: al quitar la scrollbar la página se
  // ensancharía ~15px y la zona de grabado (posicionada en % del preview) se
  // desplazaría — el diseño "se movía a la izquierda" al abrir un modal.
  // Compensamos con padding-right del mismo ancho que la scrollbar.
  function lockBodyScroll() {
    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
  }

  function unlockBodyScroll() {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  function openZoom() {
    if (!zoomModal) return;
    // Portal al <body>: evita que un ancestro con transform/sticky (solo en
    // móvil) rompa el position:fixed y deje el modal atrapado bajo el preview.
    if (zoomModal.parentElement !== document.body) document.body.appendChild(zoomModal);
    buildZoomPreview(zoomContainer);
    zoomModal.style.display = 'flex';
    lockBodyScroll();
  }

  function closeZoom() {
    if (!zoomModal) return;
    zoomModal.style.display = 'none';
    // Si el modal de confirmación sigue abierto detrás, el scroll debe
    // permanecer bloqueado (si no, la scrollbar reaparece y mueve el layout).
    var _cm = document.getElementById('pv2-confirm-modal');
    var _confirmOpen = _cm && _cm.style.display !== 'none';
    if (!_confirmOpen) unlockBodyScroll();
  }

  // ── Design scale ───────────────────────────────────
  function applyDesignScale() {
    if (engraveZone) engraveZone.style.setProperty('--design-scale', designScalePct + '%');
    var disp = document.getElementById('pv2-size-pct-display');
    if (disp) disp.textContent = designScalePct + '%';
    accSetValue('pv2-acc-size-val', designScalePct + '%');
    if (propSize) propSize.value = designScalePct + '%';
  }

  // ── Color filter ───────────────────────────────────
  function filterColors(model) {
    var available = colorsForModel(model);
    document.querySelectorAll('.pv2-color-swatch').forEach(function (sw) {
      var show = available.indexOf(sw.dataset.color) !== -1;
      sw.style.display = show ? '' : 'none';
      sw.disabled      = !show;
    });
  }

  // ── Image swap ─────────────────────────────────────
  function swapImage(variantId) {
    var url = variantImages[variantId];
    if (productImg && url) {
      productImg.src    = url;
      productImg.srcset = '';
    }
  }

  // ── Price update ───────────────────────────────────
  function updatePrice(variantId) {
    var data = variantPrices[variantId];
    if (!data) return;

    var stickyPrice = document.getElementById('pv2-sticky-price');
    // Sin "MXN" en la cápsula: espacio compacto (el precio grande sí lo lleva)
    if (stickyPrice) stickyPrice.textContent = String(data.price).replace(/\s*MXN\s*$/, '');

    var priceEl = document.querySelector('.pv2-price .price');
    if (!priceEl) return;

    priceEl.classList.toggle('price--on-sale', data.onSale);
    priceEl.classList.toggle('price--sold-out', !data.available);

    var regularEl = priceEl.querySelector('.price__regular .price-item--regular');
    if (regularEl) regularEl.textContent = data.price;

    var saleStrikeEl = priceEl.querySelector('.price__sale s.price-item--regular');
    if (saleStrikeEl) saleStrikeEl.textContent = data.compareAt;

    var salePriceEl = priceEl.querySelector('.price__sale .price-item--sale');
    if (salePriceEl) salePriceEl.textContent = data.price;
  }

  // ── Add-to-cart state ──────────────────────────────
  function updateAddBtn(variant) {
    var avail = variant && variant.available;
    if (addBtn) {
      addBtn.disabled    = !avail;
      addBtn.textContent = avail ? 'Agregar al carrito' : 'Agotado';
    }
    var buyNowBtn = document.getElementById('pv2-buy-now-btn');
    if (buyNowBtn) buyNowBtn.disabled = !avail;

    // Sticky bar: botón, modelo y miniatura en sync con la variante
    var stickyAdd = document.getElementById('pv2-sticky-add-btn');
    if (stickyAdd) {
      stickyAdd.disabled = !avail;
      // El texto vive en un span aparte para no borrar el ícono del carrito
      var stickyLabel = document.getElementById('pv2-sticky-add-label') || stickyAdd;
      stickyLabel.textContent = avail ? 'Agregar al carrito' : 'Agotado';
    }
    var stickyBuy = document.getElementById('pv2-sticky-buynow-btn');
    if (stickyBuy) stickyBuy.disabled = !avail;
    var stickyModel = document.getElementById('pv2-sticky-model');
    if (stickyModel && selectedModel) stickyModel.textContent = selectedModel;
    var stickyImg = document.getElementById('pv2-sticky-img');
    if (stickyImg && variant && variantImages[variant.id]) stickyImg.src = variantImages[variant.id];
  }

  // ── Select model ───────────────────────────────────
  function selectModel(name) {
    selectedModel = name;
    updateModelColorValue();

    document.querySelectorAll('.pv2-model-btn').forEach(function (b) {
      b.classList.toggle('pv2-model-btn--active', b.dataset.model === name);
    });

    filterColors(name);
    applyModelConfig(name);
    applyDesignScale();
    updateLayout();

    var available = colorsForModel(name);
    if (available.indexOf(selectedColor) === -1) {
      selectedColor = available[0] || null;
      document.querySelectorAll('.pv2-color-swatch').forEach(function (sw) {
        sw.classList.toggle('pv2-color-swatch--active', sw.dataset.color === selectedColor);
      });
      if (selectedColor) updateModelColorValue();
    }

    var v = findVariant(selectedModel, selectedColor);
    if (v) {
      selectedVariant    = v;
      variantInput.value = v.id;
      swapImage(v.id);
      updatePrice(v.id);
      updateAddBtn(v);
    }

    applyEngravingColor(selectedColor);
  }

  // ── Select color ───────────────────────────────────
  function selectColor(name) {
    selectedColor = name;
    updateModelColorValue();

    document.querySelectorAll('.pv2-color-swatch').forEach(function (sw) {
      sw.classList.toggle('pv2-color-swatch--active', sw.dataset.color === name);
    });

    var v = findVariant(selectedModel, selectedColor);
    if (v) {
      selectedVariant    = v;
      variantInput.value = v.id;
      swapImage(v.id);
      updatePrice(v.id);
      updateAddBtn(v);
    }

    applyEngravingColor(name);
  }

  // ── Skip button ────────────────────────────────────
  function updateSkipBtn() {
    var skipBtn = document.getElementById('pv2-nav-skip-btn');
    if (!skipBtn) return;
    var hasText = textInput && textInput.value.length > 0;
    skipBtn.textContent = hasText ? 'Listo' : 'Omitir';
    skipBtn.classList.toggle('pv2-nav-btn--next', hasText);
    skipBtn.classList.toggle('pv2-nav-btn--prev', !hasText);
    skipBtn.disabled = hasText && lineLimitHit;
  }

  // ── Text preview ───────────────────────────────────
  function updateText() {
    var maxMsg = document.getElementById('pv2-textsize-max-msg');
    if (maxMsg) maxMsg.style.display = 'none';
    var text = textInput ? textInput.value : '';
    if (propText) propText.value = text;
    if (propFont) propFont.value = text ? selectedFont : '';
    if (charNum)  charNum.textContent = text.length;

    var hasText = text.length > 0;
    var textLines = text.split('\n');
    if (linesCounterMsg) linesCounterMsg.style.display = (hasText && textLines.length >= 5) ? '' : 'none';
    if (textLayer)    textLayer.style.display    = hasText ? '' : 'none';
    if (textControls) textControls.style.display = hasText ? '' : 'none';
    accSetValue('pv2-acc-text-val', hasText ? text.replace(/\n/g, ' ') : 'Opcional');

    updateLayout();
    updateTextSizeBtn();
    updateSkipBtn();
    updateTextMetallic();
  }

  function updateTextSizeBtn() {
    var btnUp   = document.querySelector('.pv2-text-up');
    var btnDown = document.querySelector('.pv2-text-down');
    var hasText = textInput && textInput.value.length > 0;
    if (btnUp)   btnUp.disabled   = hasText && textAtMax;
    if (btnDown) btnDown.disabled = hasText && textAtMin;
    var maxMsg = document.getElementById('pv2-textsize-max-msg');
    var minMsg = document.getElementById('pv2-textsize-min-msg');
    if (maxMsg) maxMsg.style.display = (hasText && textAtMax && !lineLimitHit) ? '' : 'none';
    if (minMsg) minMsg.style.display = (hasText && textAtMin) ? '' : 'none';
    if (linesMaxMsg) linesMaxMsg.style.display = (hasText && lineLimitHit) ? '' : 'none';
  }

  // ── Text measurement (canvas) ──────────────────────────
  var lastTextPx   = 0;
  var textAtMax    = false;
  var textAtMin    = false;
  var lineLimitHit = false;
  var linesMaxMsg    = null;
  var linesCounterMsg = null;
  var wordLimitMsg   = null;
  // Medición DOM-based del ancho de texto: refleja EXACTAMENTE lo que el browser
  // renderizará, incluyendo font hinting en tamaños pequeños y el peso real de la
  // fuente. Canvas mide con peso default (400) y sin hinting → produce mediciones
  // sistemáticamente menores que el render real, especialmente en móvil donde el
  // hinting tiene más impacto relativo. Esto causaba que el texto se viera
  // proporcionalmente diferente entre pantallas.
  var _domProbe = null;
  var _currentFontWeight = '400';
  function measureW(str, px, font) {
    if (!_domProbe) {
      _domProbe = document.createElement('span');
      _domProbe.style.cssText = 'position:absolute;visibility:hidden;top:-99999px;left:0;white-space:nowrap;pointer-events:none;line-height:1';
      document.body.appendChild(_domProbe);
    }
    _domProbe.style.fontSize   = px + 'px';
    _domProbe.style.fontFamily = font;
    _domProbe.style.fontWeight = _currentFontWeight;
    _domProbe.textContent = str;
    return _domProbe.getBoundingClientRect().width;
  }
  function wrapLines(raw, px, font, maxW) {
    var out   = [];
    var paras = raw.split('\n');
    for (var i = 0; i < paras.length; i++) {
      // Colapsar espacios (inicial/doble/final) igual que lo hace el browser al
      // renderizar: si no, el canvas los dibuja literales y el bloque de glifos
      // queda descentrado → la última letra se corta en la imagen generada.
      var words = paras[i].replace(/\s+/g, ' ').trim().split(' ');
      var line  = '';
      for (var j = 0; j < words.length; j++) {
        var cand = line ? line + ' ' + words[j] : words[j];
        if (cand.length <= MAX_LINE_CHARS) {
          line = cand;
        } else {
          if (line) out.push(line);
          line = words[j];
        }
      }
      if (line !== '' || paras[i] === '') out.push(line);
    }
    return out.length ? out : [''];
  }

  function breakLine(text, px, font, maxW) {
    var lines = [];
    var current = '';
    for (var i = 0; i < text.length; i++) {
      var cand = current + text[i];
      if (measureW(cand, px, font) <= maxW && cand.length <= MAX_LINE_CHARS) {
        current = cand;
      } else {
        if (current) lines.push(current);
        current = text[i];
      }
    }
    if (current) lines.push(current);
    return lines.length ? lines : [text];
  }

  // Divide una línea por palabras (espacios) intentando caber en maxW a px.
  // Si una palabra individual no cabe, la rompe por caracteres con breakLine.
  // Esto evita cortar "Juan Jose" en "Juan Jos" + "e"; mejor lo divide en "Juan" + "Jose".
  function wrapByWords(line, px, font, maxW) {
    var words = line.split(' ');
    var out = [];
    var current = '';
    for (var i = 0; i < words.length; i++) {
      var word = words[i];
      var cand = current ? current + ' ' + word : word;
      if (measureW(cand, px, font) <= maxW && cand.length <= MAX_LINE_CHARS) {
        current = cand;
      } else {
        if (current) out.push(current);
        // ¿La palabra sola cabe? Si no, partirla por caracteres
        if (measureW(word, px, font) <= maxW && word.length <= MAX_LINE_CHARS) {
          current = word;
        } else {
          var subs = breakLine(word, px, font, maxW);
          for (var j = 0; j < subs.length - 1; j++) out.push(subs[j]);
          current = subs[subs.length - 1] || '';
        }
      }
    }
    if (current) out.push(current);
    return out.length ? out : [line];
  }

  function computeLines(lines, basePx, font, maxW, minPx) {
    if (minPx === undefined) minPx = 8;
    var out = [];
    for (var i = 0; i < lines.length; i++) {
      var line = lines[i];
      if (!line) { out.push({ text: line, px: basePx }); continue; }
      var w = measureW(line, basePx, font);
      if (w <= maxW) {
        out.push({ text: line, px: basePx });
      } else {
        var scaledPx = basePx * maxW / w;
        if (scaledPx >= minPx) {
          out.push({ text: line, px: scaledPx });
        } else {
          // No cabe ni al mínimo: dividir por PALABRAS (no por caracteres)
          var subLines = wrapByWords(line, minPx, font, maxW);
          for (var j = 0; j < subLines.length; j++) {
            out.push({ text: subLines[j], px: minPx });
          }
        }
      }
    }
    return out.length ? out : [{ text: '', px: basePx }];
  }

  // ── Auto layout: design + text when text is present ──
  function updateLayout() {
    var text    = textInput ? textInput.value : '';
    var hasText = text.length > 0;
    var designLayer = document.getElementById('pv2-design-layer');
    if (!designLayer || !engraveZone) return;

    if (hasText) {
      var zW = engraveZone.offsetWidth;
      var zH = engraveZone.offsetHeight;
      if (!zW || !zH) return;

      var maxDesignW = zW * 0.90;
      var maxDesignH = zH * 0.50;

      var svgImg = document.getElementById('pv2-design-img');
      var natW   = svgImg ? (svgImg.naturalWidth  || 0) : 0;
      var natH   = svgImg ? (svgImg.naturalHeight || 0) : 0;

      var designW, designH;
      if (natW > 0 && natH > 0) {
        var s = Math.min(maxDesignW / natW, maxDesignH / natH);
        designW = natW * s;
        designH = natH * s;
      } else {
        designW = maxDesignW;
        designH = maxDesignH;
      }

      // Todas las dimensiones son puramente proporcionales a la zona de grabado.
      // Sin pisos absolutos en píxeles para que el diseño se vea idéntico en cualquier
      // tamaño de pantalla (mobile portrait, desktop, etc).
      // safeW/maxTextW al 82% para que el texto nunca toque las líneas de la zona
      // de grabado (queda 9% de margen a cada lado).
      var _fm = fontFamilyMap[selectedFont];
      _currentFontWeight = _fm ? _fm.weight : '400';
      var fontStr     = '"' + selectedFont + '", sans-serif';
      var safeW       = zW * 0.82;
      var maxTextW    = zW * 0.82;
      var gap         = zH * 0.07;
      var remaining   = zH - designH - gap;
      var minFontPx   = zH * 0.055;
      var basePx      = Math.max(minFontPx, Math.min(remaining * 0.65, zW * 0.14));
      var requestedPx = Math.max(minFontPx, Math.min(basePx * textScale / 100, remaining * 0.88));
      var textPx      = requestedPx;

      // Wrap por límite de 24 caracteres (determinístico, independiente del tamaño de fuente)
      lineLimitHit = false;
      var rawLines = wrapLines(text, textPx, fontStr, safeW);
      if (rawLines.length > 5) { rawLines = rawLines.slice(0, 5); lineLimitHit = true; }

      // Reducir tamaño si el bloque no cabe verticalmente
      var textH = rawLines.length * textPx * 1.2;
      if (textH > remaining * 0.88 && textPx > minFontPx) {
        textPx = Math.max(minFontPx, textPx * (remaining * 0.88) / textH);
        textH  = rawLines.length * textPx * 1.2;
      }

      var lineObjs = computeLines(rawLines, textPx, fontStr, safeW, minFontPx);
      // Garantía absoluta: nunca más de 5 líneas renderizadas (breakLine puede expandir lineObjs)
      if (lineObjs.length > 5) {
        lineObjs = lineObjs.slice(0, 5);
        lineLimitHit = true;
      }
      textH = 0;
      for (var k = 0; k < lineObjs.length; k++) textH += lineObjs[k].px * 1.2;

      // Si el texto no cabe verticalmente, encoger el diseño SVG
      if (textH > remaining * 0.88) {
        var freeH = zH - textH - gap;
        if (freeH > 0 && natW > 0 && natH > 0) {
          var sR = Math.min((zW * 0.90) / natW, freeH / natH);
          designW = natW * sR;
          designH = natH * sR;
        } else {
          designW = freeH > 0 ? zW * 0.90 : 0;
          designH = Math.max(0, freeH);
        }
      }

      lastTextPx = textPx;

      // textAtMax: reducido por contenido, techo vertical, o ancho de línea al límite
      var minLineRenderedPx = textPx;
      for (var m = 0; m < lineObjs.length; m++) {
        if (lineObjs[m].px < minLineRenderedPx) minLineRenderedPx = lineObjs[m].px;
      }
      textAtMax = (textPx < requestedPx - 0.5) ||
                 (requestedPx >= remaining * 0.88 - 0.5) ||
                 (minLineRenderedPx < textPx - 0.5);
      textAtMin = (textScale <= 30) || (requestedPx <= minFontPx + 0.5);

      var textHLayout = textH;
      var totalH  = designH + gap + textHLayout;
      // Margen de borde: totalH nunca excede 95% de la zona (≥2.5% en cada lado)
      var maxTotalH = zH * 0.95;
      if (totalH > maxTotalH) {
        designH = Math.max(0, maxTotalH - gap - textHLayout);
        if (natW > 0 && natH > 0) {
          designW = designH * (natW / natH);
          if (designW > zW * 0.90) {
            designW = zW * 0.90;
            designH = designW * (natH / natW);
          }
        } else {
          designW = Math.min(designH, zW * 0.90);
        }
        totalH = designH + gap + textHLayout;
      }
      var startY = (zH - totalH) / 2;

      var designTop, textCenterY;
      if (textPosition === 'abajo') {
        designTop   = startY;
        textCenterY = startY + designH + gap + textHLayout / 2;
      } else {
        textCenterY = startY + textHLayout / 2;
        designTop   = startY + textHLayout + gap;
      }

      designLayer.style.width     = designW + 'px';
      designLayer.style.height    = designH + 'px';
      designLayer.style.top       = designTop + 'px';
      designLayer.style.left      = '50%';
      designLayer.style.transform = 'translateX(-50%)';

      if (textPreview) {
        var fm     = fontFamilyMap[selectedFont];
        var family = fm ? fm.family : fontStr;
        var weight = fm ? fm.weight : '400';
        textPreview.style.setProperty('font-family', family, 'important');
        textPreview.style.setProperty('font-weight', weight, 'important');
        var html = lineObjs.map(function (l) {
          var esc = l.text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          return '<span style="display:block;font-size:' + l.px.toFixed(1) + 'px;line-height:1.2;white-space:nowrap;font-family:' + family + ' !important;font-weight:' + weight + ' !important">' + esc + '</span>';
        }).join('');
        textPreview.innerHTML      = html;
        textPreview.style.width    = maxTextW + 'px';
        textPreview.style.height   = '';
        textPreview.style.overflow = 'visible';
        textPreview.style.fontSize = '';

        // El canvas mide ancho con fuente de fallback (puede subestimar el ancho real
        // del browser con la fuente web). Si el ancho renderizado supera maxTextW,
        // escalamos las fuentes hacia ABAJO para que TODO quepa en maxTextW.
        // Resultado: contenedor siempre mide maxTextW = mismo % de la zona en ambas
        // pantallas, las proporciones internas son idénticas.
        // Range en vez de scrollWidth: con texto centrado, scrollWidth solo cuenta
        // el desborde del lado derecho y subestima el ancho real del contenido.
        var _rng = document.createRange();
        _rng.selectNodeContents(textPreview);
        var renderedW = _rng.getBoundingClientRect().width || textPreview.scrollWidth || maxTextW;
        if (renderedW > maxTextW + 0.5) {
          var scaleDown = maxTextW / renderedW;
          var spans = textPreview.querySelectorAll('span');
          for (var sIdx = 0; sIdx < spans.length; sIdx++) {
            var span = spans[sIdx];
            var curSize = parseFloat(span.style.fontSize);
            if (!isNaN(curSize)) {
              span.style.fontSize = (curSize * scaleDown).toFixed(2) + 'px';
            }
          }
        }

        var renderedH = textPreview.scrollHeight || textHLayout;
        var finalH    = Math.max(textHLayout, renderedH);
        var finalCenterY = textCenterY + (finalH - textHLayout) / 2;

        textPreview.style.width     = maxTextW + 'px';
        textPreview.style.height    = finalH + 'px';
        textPreview.style.overflow  = 'hidden';
        textPreview.style.top       = finalCenterY + 'px';
        textPreview.style.left      = '50%';
        textPreview.style.transform = 'translate(-50%, -50%)';
      }

    } else {
      lastTextPx   = 0;
      textAtMax    = false;
      lineLimitHit = false;
      // Sin texto: limpia estilos inline para que el CSS/--design-scale vuelva a tomar control
      designLayer.style.width     = '';
      designLayer.style.height    = '';
      designLayer.style.top       = '';
      designLayer.style.left      = '';
      designLayer.style.transform = '';
      if (textPreview) {
        textPreview.innerHTML      = '';
        textPreview.style.width    = '';
        textPreview.style.height   = '';
        textPreview.style.overflow = '';
        textPreview.style.fontSize = '';
      }
    }
  }

  // ── Font loading (Google Fonts) ────────────────────
  var gfMap = {
    'EB Garamond':    'EB+Garamond',
    'Pacifico':       'Pacifico',
    'Dancing Script': 'Dancing+Script:wght@400;700',
    'Lobster':        'Lobster',
    'Nunito':         'Nunito:wght@400;700',
  };
  function loadFont(name) {
    var gf = gfMap[name];
    if (!gf || document.querySelector('link[data-gf="' + name + '"]')) return;
    var link = document.createElement('link');
    link.rel        = 'stylesheet';
    link.href       = 'https://fonts.googleapis.com/css2?family=' + gf + '&display=swap';
    link.dataset.gf = name;
    document.head.appendChild(link);
  }

  // ── Modal ──────────────────────────────────────────
  var _modalPreviewUrl = null;
  async function showModal() {
    var modal = document.getElementById('pv2-confirm-modal');
    var wrap  = document.getElementById('pv2-modal-preview-wrap');
    if (!modal) return;

    // Portal al <body>: mismo motivo que el zoom — evita que un ancestro con
    // transform/sticky rompa el position:fixed del modal en móvil.
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    // Mostrar modal inmediatamente con placeholder mientras se genera la imagen
    modal.style.display = '';
    lockBodyScroll();

    if (wrap) {
      wrap.innerHTML = '<div class="pv2-modal-preview-loading">Generando vista previa…</div>';
      try {
        var blob = await buildImageBlob({ closeup: false });
        // Liberar URL anterior si existe
        if (_modalPreviewUrl) {
          URL.revokeObjectURL(_modalPreviewUrl);
          _modalPreviewUrl = null;
        }
        wrap.innerHTML = '';
        if (blob) {
          _modalPreviewUrl = URL.createObjectURL(blob);
          var img = document.createElement('img');
          img.src = _modalPreviewUrl;
          img.alt = 'Vista previa del diseño';
          img.className = 'pv2-modal-preview-img';
          wrap.appendChild(img);

          // Botón de zoom propio (no clonado), con listener directo
          var zBtn = document.createElement('button');
          zBtn.type = 'button';
          zBtn.className = 'pv2-zoom-btn pv2-modal-zoom-btn';
          zBtn.setAttribute('aria-label', 'Ver imagen completa');
          zBtn.innerHTML =
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
            '<circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>' +
            '<line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>';
          zBtn.addEventListener('click', openZoom);
          wrap.appendChild(zBtn);
        } else {
          wrap.innerHTML = '<div class="pv2-modal-preview-loading">No se pudo generar la vista previa</div>';
        }
      } catch (err) {
        console.error('[pv2] modal preview error:', err);
        wrap.innerHTML = '<div class="pv2-modal-preview-loading">Error al generar la vista previa</div>';
      }
    }
  }

  function closeModal() {
    var modal = document.getElementById('pv2-confirm-modal');
    if (modal) modal.style.display = 'none';
    unlockBodyScroll();
    confirmed = false;
    buyNow    = false;
    if (_modalPreviewUrl) {
      URL.revokeObjectURL(_modalPreviewUrl);
      _modalPreviewUrl = null;
    }
  }

  // ── Scroll para mostrar el preview completo ────────
  function scrollToPreview() {
    var headerH = 0;
    var hpx = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (hpx) headerH = parseFloat(hpx) || 0;
    if (!headerH) {
      var hEl = document.querySelector('sticky-header, #shopify-section-header header, .site-header');
      if (hEl) headerH = hEl.offsetHeight;
    }

    if (!isMobileView()) {
      // Desktop: scroll al inicio del layout
      var layout = document.querySelector('.pv2-layout');
      if (!layout) return;
      var lrect = layout.getBoundingClientRect();
      var targetYD = window.scrollY + lrect.top - headerH - 16;
      window.scrollTo({ top: Math.max(0, targetYD), behavior: 'smooth' });
      return;
    }

    // Mobile: scroll para que el accordion abierto quede justo debajo del
    // preview encogido en su tamaño mínimo (SHRINK_END_VH).
    var openTrigger = document.querySelector('.pv2-acc__trigger--open');
    if (!openTrigger) return;

    var previewMinPx = window.innerHeight * (SHRINK_END_VH / 100);
    // Padding del wrapper .pv2-media (0.4rem top + 1.2rem bottom ≈ 16px)
    var mediaPadding = 16;
    var stickyHeight = headerH + mediaPadding + previewMinPx;

    var trect = openTrigger.getBoundingClientRect();
    var triggerDocY = window.scrollY + trect.top;
    var targetY = triggerDocY - stickyHeight - 8;
    // Garantiza que scrollY alcance el rango de encogimiento
    targetY = Math.max(SHRINK_RANGE_PX, targetY);
    window.scrollTo({ top: targetY, behavior: 'smooth' });
  }

  // Sincroniza los inputs hidden de cart properties con el estado actual del personalizador
  function syncCartProperties() {
    var hasText = textInput && textInput.value.length > 0;
    if (propTextPos) {
      propTextPos.value = hasText ? textPosition : '';
    }
    if (propTextScale) {
      propTextScale.value = hasText ? (textScale + '%') : '';
    }
    if (propLink) {
      propLink.value = buildShareUrl();
    }
  }

  // ── Share ──────────────────────────────────────────
  function buildShareUrl() {
    var url = new URL(window.location.href);
    url.search = '';
    var p = url.searchParams;
    // variant_id es la fuente de verdad inmutable de la variante seleccionada
    if (selectedVariant && selectedVariant.id) p.set('v', selectedVariant.id);
    // model + color se mantienen como fallback legible
    if (selectedModel) p.set('model', selectedModel);
    if (selectedColor) p.set('color', selectedColor);
    if (designScalePct !== 75) p.set('scale', designScalePct);
    var text = textInput ? textInput.value : '';
    if (text) p.set('text', text);
    if (selectedFont !== 'Glacial Indifference') p.set('font', selectedFont);
    if (textPosition !== 'abajo') p.set('textpos', textPosition);
    if (textScale !== 100) p.set('textscale', textScale);
    return url.toString();
  }

  function showShareToast(msg) {
    if (!shareToast) {
      shareToast = document.createElement('div');
      shareToast.className = 'pv2-share-toast';
      document.body.appendChild(shareToast);
    }
    shareToast.textContent = msg;
    shareToast.classList.add('pv2-share-toast--visible');
    clearTimeout(shareToastTimer);
    shareToastTimer = setTimeout(function () {
      shareToast.classList.remove('pv2-share-toast--visible');
    }, 2200);
  }

  function fallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); showShareToast('Diseño copiado'); } catch (e) {}
    document.body.removeChild(ta);
  }

  async function buildImageBlob(options) {
    if (!productImg || !productImg.src || !previewBox) return null;
    options = options || {};
    var closeup = !!options.closeup;

    // Capturar todos los rects DOM ANTES de cualquier await
    // El canvas debe representar el área VISIBLE del preview (.pv2-preview),
    // no el rect del <img> completo. En móvil, .pv2-preview tiene height: 24vh
    // fijo y el <img> se centra dentro (letterboxed con max-width/max-height),
    // por lo que usar imgRect produciría dimensiones distintas a lo que ve el
    // usuario. Usamos boxRect (el contenedor con overflow:hidden) como lienzo
    // y dibujamos cada capa en sus coordenadas reales relativas a ese contenedor.
    var boxRect  = previewBox.getBoundingClientRect();
    var imgRect  = productImg.getBoundingClientRect();
    var displayW = Math.round(boxRect.width);
    var displayH = Math.round(boxRect.height);
    if (!displayW || !displayH) return null;

    // Offset del <img> dentro del contenedor (puede haber letterbox en móvil)
    var imgOffsetX = imgRect.left - boxRect.left;
    var imgOffsetY = imgRect.top  - boxRect.top;
    var imgW       = imgRect.width;
    var imgH       = imgRect.height;

    // Modo metálico: detectar via clases del preview + URL de textura + brightness
    var isMetallic      = previewBox.classList.contains('pv2-preview--metallic');
    var isLight         = previewBox.classList.contains('pv2-preview--metallic-light');
    var textureUrl      = previewBox.dataset.textureUrl    || '';
    var metalBrightness = parseFloat(previewBox.dataset.metalBrightness) || 0.7;
    var lightFilter     = isLight ? 'brightness(' + metalBrightness + ')' : '';

    var designImgEl  = document.getElementById('pv2-design-img');
    var designLayer  = document.getElementById('pv2-design-layer');
    var designSrc    = designImgEl ? designImgEl.src          : null;
    var designFilter = designImgEl ? designImgEl.style.filter : '';
    // En modo metálico el <img> tiene display:none → su rect es 0×0.
    // Usamos siempre el rect del design-layer (parent), que es visible en ambos modos
    // y tiene el mismo tamaño que el <img> cuando está visible.
    var dr = designLayer ? designLayer.getBoundingClientRect() : null;

    var hasText  = textLayer && textLayer.style.display !== 'none' && textPreview;
    var tRect    = hasText ? textPreview.getBoundingClientRect() : null;
    var tColor   = hasText ? (textPreview.style.color      || '#888888') : '';
    var tFontFam = hasText ? (textPreview.style.fontFamily || '')        : '';
    var tFontW   = hasText ? (textPreview.style.fontWeight || '400')     : '';
    var spanData = hasText ? Array.from(textPreview.querySelectorAll('span')).map(function (s) {
      return {
        text:   s.textContent,
        px:     parseFloat(s.style.fontSize) || 16,
        family: s.style.fontFamily || tFontFam || 'sans-serif',
        weight: s.style.fontWeight || tFontW   || '400'
      };
    }) : [];

    var PR = 4;

    // Helper: transforma una URL de Shopify CDN a su versión de alta resolución (2000px wide)
    function toHiResUrl(url) {
      return url.replace(
        /(_\d+x(?:\d+)?)?\.([a-zA-Z]+)(\?.*)?$/,
        function (_match, _size, ext, query) {
          return '_2000x.' + ext + (query || '');
        }
      );
    }

    // Helper: carga una imagen vía fetch+blob URL para bypassear CORS al usarla en canvas.
    async function loadCanvasSafe(url) {
      try {
        var resp = await fetch(url, { mode: 'cors' });
        if (resp.ok) {
          var blob = await resp.blob();
          var objUrl = URL.createObjectURL(blob);
          var img = new Image();
          var ok = await new Promise(function (r) {
            img.onload  = function () { r(true);  };
            img.onerror = function () { r(false); };
            img.src = objUrl;
          });
          if (ok) return { img: img, revoke: function () { URL.revokeObjectURL(objUrl); } };
          URL.revokeObjectURL(objUrl);
        }
      } catch (e) { /* fallback abajo */ }
      var fallback = new Image();
      fallback.crossOrigin = 'anonymous';
      var fbOk = await new Promise(function (r) {
        fallback.onload  = function () { r(true);  };
        fallback.onerror = function () { r(false); };
        fallback.src = url;
      });
      return fbOk ? { img: fallback, revoke: function () {} } : null;
    }

    if (document.fonts && document.fonts.ready) { await document.fonts.ready; }

    // Cargar el SVG temprano: necesitamos sus dimensiones naturales para
    // calcular el bounding box real del diseño en modo closeup.
    var svgResult = (designSrc && dr) ? await loadCanvasSafe(designSrc) : null;
    var svgLoad   = svgResult ? svgResult.img : null;

    // Calcular el rect del SVG visible (replicando object-fit: contain)
    var svgFit = null;
    if (svgLoad && dr && dr.width > 0 && dr.height > 0) {
      var _dx = dr.left - boxRect.left;
      var _dy = dr.top  - boxRect.top;
      var _dw = dr.width;
      var _dh = dr.height;
      var _svgNatW = svgLoad.naturalWidth  || _dw;
      var _svgNatH = svgLoad.naturalHeight || _dh;
      var _svgAR   = _svgNatW / _svgNatH;
      var _rectAR  = _dw / _dh;
      var _fitW, _fitH;
      if (_svgAR > _rectAR) { _fitW = _dw; _fitH = _dw / _svgAR; }
      else                  { _fitH = _dh; _fitW = _dh * _svgAR; }
      svgFit = {
        x: _dx + (_dw - _fitW) / 2,
        y: _dy + (_dh - _fitH) / 2,
        w: _fitW,
        h: _fitH
      };
    }

    // Canvas en coordenadas de pantalla ×4. En modo closeup: cuadrado centrado
    // en el bounding box REAL del contenido visible (SVG + texto), no en la zona
    // de grabado completa. Así el zoom se adapta al tamaño real del diseño.
    var canvasW, canvasH, drawOffsetX = 0, drawOffsetY = 0;

    if (closeup) {
      var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
      if (svgFit) {
        minX = Math.min(minX, svgFit.x);
        minY = Math.min(minY, svgFit.y);
        maxX = Math.max(maxX, svgFit.x + svgFit.w);
        maxY = Math.max(maxY, svgFit.y + svgFit.h);
      }
      if (hasText && tRect) {
        var _txL = tRect.left - boxRect.left;
        var _txT = tRect.top  - boxRect.top;
        minX = Math.min(minX, _txL);
        minY = Math.min(minY, _txT);
        maxX = Math.max(maxX, _txL + tRect.width);
        maxY = Math.max(maxY, _txT + tRect.height);
      }

      if (minX !== Infinity) {
        var _contentW  = maxX - minX;
        var _contentH  = maxY - minY;
        var _contentCx = (minX + maxX) / 2;
        var _contentCy = (minY + maxY) / 2;
        // Padding alrededor del contenido (40% del lado más grande)
        var _squareSize = Math.max(_contentW, _contentH) * 1.4;
        canvasW = canvasH = _squareSize;
        drawOffsetX = canvasW / 2 - _contentCx;
        drawOffsetY = canvasH / 2 - _contentCy;
      } else if (engraveZone) {
        // Sin contenido visible: fallback a la zona de grabado
        var _ezRect = engraveZone.getBoundingClientRect();
        var _ezCx = _ezRect.left + _ezRect.width  / 2 - boxRect.left;
        var _ezCy = _ezRect.top  + _ezRect.height / 2 - boxRect.top;
        var _ezSq = Math.max(_ezRect.width, _ezRect.height) * 1.7;
        canvasW = canvasH = _ezSq;
        drawOffsetX = canvasW / 2 - _ezCx;
        drawOffsetY = canvasH / 2 - _ezCy;
      } else {
        canvasW = displayW;
        canvasH = displayH;
      }
    } else {
      canvasW = displayW;
      canvasH = displayH;
    }

    var canvas = document.createElement('canvas');
    canvas.width  = Math.round(canvasW * PR);
    canvas.height = Math.round(canvasH * PR);
    var ctx = canvas.getContext('2d');
    ctx.scale(PR, PR);
    if (drawOffsetX || drawOffsetY) ctx.translate(drawOffsetX, drawOffsetY);

    // 1. Imagen del producto: dibujada en su posición real dentro del preview
    // Usamos versión 2000px para mayor calidad en el PNG compartido
    var hiResSrc   = toHiResUrl(productImg.src);
    var prodResult = await loadCanvasSafe(hiResSrc);
    if (!prodResult) {
      // Si la versión 2000px no carga (raro), caemos al src original
      prodResult = await loadCanvasSafe(productImg.src);
    }
    var prodLoad   = prodResult ? prodResult.img : null;
    var prodLoaded = !!prodResult;

    if (prodLoaded && imgW > 0 && imgH > 0) {
      // Forzar aspect ratio natural: si por alguna razón el rect rendereado
      // tiene un AR distinto al natural (poco probable pero posible), se
      // dibuja la imagen "contenida" (object-fit: contain) dentro del rect del img.
      var natW = prodLoad.naturalWidth  || imgW;
      var natH = prodLoad.naturalHeight || imgH;
      var rectAR = imgW / imgH;
      var natAR  = natW / natH;
      var drawW, drawH, drawX, drawY;
      // Tolerancia 0.5% — si los AR coinciden, usar el rect tal cual (sin letterbox extra)
      if (Math.abs(rectAR - natAR) / natAR < 0.005) {
        drawW = imgW; drawH = imgH;
        drawX = imgOffsetX; drawY = imgOffsetY;
      } else {
        // Contener dentro del rect respetando aspect ratio natural
        if (natAR > rectAR) {
          drawW = imgW;
          drawH = imgW / natAR;
        } else {
          drawH = imgH;
          drawW = imgH * natAR;
        }
        drawX = imgOffsetX + (imgW - drawW) / 2;
        drawY = imgOffsetY + (imgH - drawH) / 2;
      }
      ctx.drawImage(prodLoad, drawX, drawY, drawW, drawH);
    }

    // Cargar textura metálica si aplica (vía fetch+blob para bypass CORS canvas)
    var metalTex = null;
    var metalTexRevoke = null;
    if (isMetallic && textureUrl) {
      var texResult = await loadCanvasSafe(textureUrl);
      if (texResult && texResult.img.naturalWidth) {
        metalTex = texResult.img;
        metalTexRevoke = texResult.revoke;
      }
    }

    // Helper: calcular crop "cover" de una textura para llenar un rect destino
    function coverCrop(tex, destW, destH) {
      var tAR = tex.naturalWidth / tex.naturalHeight;
      var dAR = destW / destH;
      var sx, sy, sw, sh;
      if (tAR > dAR) {
        sh = tex.naturalHeight;
        sw = sh * dAR;
        sx = (tex.naturalWidth - sw) / 2;
        sy = 0;
      } else {
        sw = tex.naturalWidth;
        sh = sw / dAR;
        sx = 0;
        sy = (tex.naturalHeight - sh) / 2;
      }
      return { sx: sx, sy: sy, sw: sw, sh: sh };
    }

    // 2. Diseño SVG — usar svgFit precomputado al inicio (la carga ya ocurrió arriba)
    if (svgLoad && svgFit) {
      var fitX = svgFit.x;
      var fitY = svgFit.y;
      var fitW = svgFit.w;
      var fitH = svgFit.h;
      if (fitW > 0 && fitH > 0) {
        if (isMetallic && metalTex) {
          // Offscreen a PR× para no perder resolución al componer textura+máscara SVG
          var off = document.createElement('canvas');
          off.width  = Math.max(1, Math.ceil(fitW * PR));
          off.height = Math.max(1, Math.ceil(fitH * PR));
          var offCtx = off.getContext('2d');
          var c = coverCrop(metalTex, off.width, off.height);
          offCtx.drawImage(metalTex, c.sx, c.sy, c.sw, c.sh, 0, 0, off.width, off.height);
          offCtx.globalCompositeOperation = 'destination-in';
          offCtx.drawImage(svgLoad, 0, 0, off.width, off.height);
          if (isLight && lightFilter) ctx.filter = lightFilter;
          // Destino en coords de display (ctx ya tiene scale(PR)) → mapeo 1:1 con offscreen
          ctx.drawImage(off, fitX, fitY, fitW, fitH);
          ctx.filter = 'none';
        } else {
          if (designFilter) ctx.filter = designFilter;
          ctx.drawImage(svgLoad, fitX, fitY, fitW, fitH);
          ctx.filter = 'none';
        }
      }
    }

    // 3. Texto — posición exacta relativa al contenedor preview
    if (hasText && tRect && spanData.length) {
      var centerX = tRect.left + tRect.width / 2 - boxRect.left;
      var topY    = tRect.top - boxRect.top;

      if (isMetallic && metalTex) {
        // Offscreen a PR× resolución del bounding box del texto.
        // Dibujamos texto blanco escalado, luego rellenamos con textura via 'source-in'.
        // El ancho toma el MAYOR entre el rect del DOM y el ancho real medido en
        // canvas (+2px): cualquier discrepancia de medición DOM↔canvas ya no
        // amputa la última letra al recortar contra el borde del offscreen.
        var _maxLineW = 0;
        spanData.forEach(function (s) {
          ctx.font = s.weight + ' ' + s.px.toFixed(1) + 'px ' + s.family;
          var _lw = ctx.measureText(s.text).width;
          if (_lw > _maxLineW) _maxLineW = _lw;
        });
        var tW_disp = Math.max(1, Math.ceil(tRect.width), Math.ceil(_maxLineW) + 2);
        var totalTH = 0;
        spanData.forEach(function (s) { totalTH += s.px * 1.2; });
        var tH_disp = Math.max(1, Math.ceil(totalTH));
        var tW = tW_disp * PR;
        var tH = tH_disp * PR;
        var tOff = document.createElement('canvas');
        tOff.width  = tW;
        tOff.height = tH;
        var tCtx = tOff.getContext('2d');
        tCtx.scale(PR, PR);  // todas las ops siguientes en coords display, render a PR×
        tCtx.fillStyle    = '#FFFFFF';
        tCtx.textAlign    = 'center';
        tCtx.textBaseline = 'top';
        var localCx = tW_disp / 2;
        var localY  = 0;
        spanData.forEach(function (s) {
          tCtx.font = s.weight + ' ' + s.px.toFixed(1) + 'px ' + s.family;
          tCtx.fillText(s.text, localCx, localY);
          localY += s.px * 1.2;
        });
        tCtx.globalCompositeOperation = 'source-in';
        var ct = coverCrop(metalTex, tW, tH);
        tCtx.drawImage(metalTex, ct.sx, ct.sy, ct.sw, ct.sh, 0, 0, tW_disp, tH_disp);
        if (isLight && lightFilter) ctx.filter = lightFilter;
        // Destino en coords display (ctx tiene scale(PR)) → offscreen PR× se mapea 1:1
        ctx.drawImage(tOff, centerX - tW_disp / 2, topY, tW_disp, tH_disp);
        ctx.filter = 'none';
      } else {
        var curY = topY;
        ctx.fillStyle    = tColor;
        ctx.textAlign    = 'center';
        ctx.textBaseline = 'top';
        spanData.forEach(function (s) {
          ctx.font = s.weight + ' ' + s.px.toFixed(1) + 'px ' + s.family;
          ctx.fillText(s.text, centerX, curY);
          curY += s.px * 1.2;
        });
      }
    }

    return new Promise(function (res) {
      canvas.toBlob(function (blob) {
        // Liberar object URLs creadas por loadCanvasSafe
        if (prodResult && prodResult.revoke) prodResult.revoke();
        if (svgResult  && svgResult.revoke)  svgResult.revoke();
        if (metalTexRevoke) metalTexRevoke();
        res(blob);
      }, 'image/png');
    });
  }

  // Descarga genérica: closeup cuadrado del diseño O termo completo, según opts
  async function _downloadPreview(opts, btnId, filename) {
    var btn = document.getElementById(btnId);
    if (btn) btn.disabled = true;
    try {
      var blob = await buildImageBlob(opts);
      if (blob) {
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(function () { URL.revokeObjectURL(blobUrl); }, 2000);
        showShareToast('Imagen descargada');
      } else {
        showShareToast('No hay diseño para descargar');
      }
    } catch (e) {
      console.error('[pv2] download image error:', e);
      showShareToast('No se pudo descargar la imagen');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  function handleDownloadCloseup() {
    return _downloadPreview({ closeup: true }, 'pv2-copy-img-btn', 'kunk-personalizado-closeup.png');
  }

  function handleDownloadFull() {
    return _downloadPreview({ closeup: false }, 'pv2-full-img-btn', 'kunk-personalizado-termo.png');
  }

  async function handleShare() {
    var btn = document.getElementById('pv2-share-btn');
    if (btn) btn.disabled = true;

    try {
      var shareUrl = buildShareUrl();
      var shareMsg = SHARE_TEXT + '\n' + shareUrl;

      // 1. Web Share API (texto + link, sin imagen) — abre sheet nativo.
      //    No adjuntamos archivo: apps como WhatsApp descartan el texto/link
      //    cuando el share incluye una imagen, y el link es lo esencial.
      if (navigator.share && typeof navigator.share === 'function') {
        try {
          await navigator.share({ text: SHARE_TEXT, url: shareUrl, title: 'Mi diseño KUNK' });
          showShareToast('¡Compartido!');
          return;
        } catch (shareErr) {
          // AbortError = usuario canceló el sheet; no es un error real
          if (shareErr && shareErr.name === 'AbortError') return;
          console.warn('[pv2] web share falló, intentando clipboard:', shareErr);
        }
      }

      // 2. Fallback: copiar texto + link al portapapeles
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(shareMsg);
      } else {
        fallbackCopy(shareMsg);
      }
      showShareToast('Mensaje y link copiados');

    } catch (e) {
      console.error('[pv2] share error:', e);
      showShareToast('No se pudo compartir');
    } finally {
      if (btn) btn.disabled = false;
    }
  }

  // ── Accordion ──────────────────────────────────────
  function initAccordion() {
    document.querySelectorAll('.pv2-acc__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen = trigger.classList.contains('pv2-acc__trigger--open');
        closeAllAccordions();
        if (!isOpen) {
          trigger.classList.add('pv2-acc__trigger--open');
          var body = trigger.parentElement.querySelector('.pv2-acc__body');
          if (body) body.style.display = '';
          requestAnimationFrame(scrollToPreview);
        }
      });
    });

    // Nav buttons (Siguiente / Anterior / Omitir)
    document.querySelectorAll('[data-nav-to]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var target = btn.dataset.navTo;
        if (target === 'done') {
          closeAllAccordions();
          // "Listo" u "Omitir" en el paso de texto: abrir directamente el
          // modal de confirmación para agregar al carrito.
          if (btn.id === 'pv2-nav-skip-btn') {
            syncCartProperties();
            showModal();
          } else {
            requestAnimationFrame(scrollToTopOfLayout);
          }
        } else {
          openAccordion(target);
          requestAnimationFrame(scrollToPreview);
        }
      });
    });
  }

  // Scroll a la parte superior del configurador para que se vea
  // el preview completo, todos los pasos cerrados y los botones de compra.
  function scrollToTopOfLayout() {
    var target = document.querySelector('.pv2-layout');
    if (!target) return;
    var headerH = 0;
    var hpx = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    if (hpx) headerH = parseFloat(hpx) || 0;
    if (!headerH) {
      var hEl = document.querySelector('sticky-header, #shopify-section-header header, .site-header');
      if (hEl) headerH = hEl.offsetHeight;
    }
    var rect = target.getBoundingClientRect();
    var targetY = window.scrollY + rect.top - headerH - 16;
    window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
  }

  // ── Init ───────────────────────────────────────────
  function init() {
    var modelEl = document.querySelector('.pv2-model-btns');
    var colorEl = document.querySelector('.pv2-color-swatches');
    if (modelEl) modelOptionIdx = parseInt(modelEl.dataset.optionIndex, 10);
    if (colorEl) colorOptionIdx = parseInt(colorEl.dataset.optionIndex, 10);

    if (variants.length > 0) {
      var initId = parseInt((variantInput && variantInput.value) || '0', 10);
      selectedVariant = variants.filter(function (v) { return v.id === initId; })[0] || variants[0];
      if (selectedVariant) {
        selectedModel = getOption(selectedVariant, modelOptionIdx);
        selectedColor = getOption(selectedVariant, colorOptionIdx);
      }
    }

    if (selectedModel) {
      applyModelConfig(selectedModel);
      filterColors(selectedModel);
      applyDesignScale();
    }

    applyEngravingColor(selectedColor);
    applyMetallicMask();
    initShrinkOnScroll();

    initAccordion();

    // Inyectar mensaje de límite de líneas junto al mensaje de tamaño máximo
    var sizMaxEl = document.getElementById('pv2-textsize-max-msg');
    if (sizMaxEl && !document.getElementById('pv2-lines-max-msg')) {
      linesMaxMsg           = document.createElement('p');
      linesMaxMsg.id        = 'pv2-lines-max-msg';
      linesMaxMsg.className = sizMaxEl.className;
      linesMaxMsg.style.display = 'none';
      linesMaxMsg.textContent   = 'Máximo 5 líneas para el grabado';
      sizMaxEl.parentNode.insertBefore(linesMaxMsg, sizMaxEl.nextSibling);
    }

    // Mensaje debajo del contador de caracteres: límite de líneas manuales
    var charCountEl = document.querySelector('.pv2-char-count');
    if (charCountEl && !document.getElementById('pv2-lines-counter-msg')) {
      linesCounterMsg           = document.createElement('p');
      linesCounterMsg.id        = 'pv2-lines-counter-msg';
      linesCounterMsg.className = 'pv2-textsize-max-msg';
      linesCounterMsg.style.display = 'none';
      linesCounterMsg.textContent   = 'Llegaste al límite de saltos de línea (5)';
      charCountEl.parentNode.insertBefore(linesCounterMsg, charCountEl.nextSibling);
    }

    // Mensaje: límite de caracteres por palabra
    if (charCountEl && !document.getElementById('pv2-word-limit-msg')) {
      wordLimitMsg           = document.createElement('p');
      wordLimitMsg.id        = 'pv2-word-limit-msg';
      wordLimitMsg.className = 'pv2-textsize-max-msg';
      wordLimitMsg.style.display = 'none';
      wordLimitMsg.textContent   = 'Máximo ' + MAX_WORD_CHARS + ' caracteres por palabra — sepáralas con un espacio';
      charCountEl.parentNode.insertBefore(wordLimitMsg, charCountEl.nextSibling);
    }

    // Design scale buttons
    var btnDesignUp   = document.querySelector('.pv2-design-up');
    var btnDesignDown = document.querySelector('.pv2-design-down');
    if (btnDesignUp) {
      btnDesignUp.addEventListener('click', function () {
        designScalePct = Math.min(designScalePct + 5, 100);
        applyDesignScale();
        updateLayout();
        btnDesignUp.disabled   = designScalePct >= 100;
        btnDesignDown.disabled = false;
      });
    }
    if (btnDesignDown) {
      btnDesignDown.addEventListener('click', function () {
        designScalePct = Math.max(designScalePct - 5, 50);
        applyDesignScale();
        updateLayout();
        btnDesignDown.disabled = designScalePct <= 50;
        btnDesignUp.disabled   = false;
      });
    }

    // Model buttons
    document.querySelectorAll('.pv2-model-btn').forEach(function (btn) {
      btn.addEventListener('click', function () { selectModel(btn.dataset.model); });
    });

    // Color swatches
    document.querySelectorAll('.pv2-color-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () { selectColor(sw.dataset.color); });
    });

    // Text input — máximo 5 líneas y 15 caracteres por palabra
    // (keydown bloquea Enter y el carácter 16 de una palabra; input clips paste)
    var wordLimitRe = new RegExp('\\S{' + (MAX_WORD_CHARS + 1) + ',}');
    function showWordLimitMsg(show) {
      if (wordLimitMsg) wordLimitMsg.style.display = show ? '' : 'none';
    }
    if (textInput) {
      textInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var lines = textInput.value.split('\n');
          if (lines.length >= 5) e.preventDefault();
        } else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey && !/\s/.test(e.key)) {
          // Simular la inserción: si generaría una palabra de más de 15
          // caracteres, bloquear la tecla y avisar.
          var v = textInput.value;
          var next = v.slice(0, textInput.selectionStart) + e.key + v.slice(textInput.selectionEnd);
          if (wordLimitRe.test(next)) {
            e.preventDefault();
            showWordLimitMsg(true);
          }
        }
      });
      textInput.addEventListener('input', function () {
        var lines = textInput.value.split('\n');
        if (lines.length > 5) {
          var cursor = textInput.selectionStart;
          textInput.value = lines.slice(0, 5).join('\n');
          textInput.selectionStart = textInput.selectionEnd = Math.min(cursor, textInput.value.length);
        }
        // Paste u otras vías: recortar cada palabra a 15 caracteres
        if (wordLimitRe.test(textInput.value)) {
          var cur2 = textInput.selectionStart;
          textInput.value = textInput.value.replace(
            new RegExp('(\\S{' + MAX_WORD_CHARS + '})\\S+', 'g'), '$1'
          );
          textInput.selectionStart = textInput.selectionEnd = Math.min(cur2, textInput.value.length);
          showWordLimitMsg(true);
        } else {
          showWordLimitMsg(false);
        }
        updateText();
      });
    }

    // Pre-cargar todas las Google Fonts al inicio
    Object.keys(gfMap).forEach(loadFont);
    document.fonts.ready.then(function () {
      if (textInput && textInput.value) updateText();
    });

    // Font previews
    function applyFontPreviews() {
      document.querySelectorAll('.pv2-font-opt').forEach(function (btn) {
        var f = fontFamilyMap[btn.dataset.font];
        if (f) {
          btn.style.setProperty('font-family', f.family, 'important');
          btn.style.setProperty('font-weight', f.weight, 'important');
        }
      });
    }
    applyFontPreviews();
    document.fonts.ready.then(applyFontPreviews);

    // Font buttons
    document.querySelectorAll('.pv2-font-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var name = btn.dataset.font;
        selectedFont = name;
        loadFont(selectedFont);
        document.querySelectorAll('.pv2-font-opt').forEach(function (b) {
          b.classList.remove('pv2-font-opt--active');
        });
        btn.classList.add('pv2-font-opt--active');
        updateText();
        var fm = fontFamilyMap[name];
        if (fm) {
          document.fonts.load(fm.weight + ' 16px ' + name).then(function () {
            if (selectedFont === name) updateText();
          }).catch(function () {});
        }
      });
    });

    // Text size
    var btnUp   = document.querySelector('.pv2-text-up');
    var btnDown = document.querySelector('.pv2-text-down');
    if (btnUp)   btnUp.addEventListener('click',   function () { textScale = Math.min(textScale + 10, 300); updateText(); });
    if (btnDown) btnDown.addEventListener('click', function () { textScale = Math.max(textScale - 10, 30);  updateText(); });

    // Color dots: click → selecciona modelo + color; hover → swap preview
    document.querySelectorAll('.pv2-model-color-dot').forEach(function (dot) {
      dot.addEventListener('click', function (e) {
        e.stopPropagation();
        var modelBtn = dot.closest('.pv2-model-btn');
        if (modelBtn) selectModel(modelBtn.dataset.model);
        selectColor(dot.dataset.color);
      });

      dot.addEventListener('mouseenter', function () {
        var imgUrl = dot.dataset.variantImg;
        if (productImg && imgUrl) {
          productImg.src    = imgUrl;
          productImg.srcset = '';
        }
        var modelBtn = dot.closest('.pv2-model-btn');
        if (modelBtn && modelBtn.dataset.model) {
          applyModelConfig(modelBtn.dataset.model);
          applyDesignScale(modelBtn.dataset.model, selectedSize);
        }
      });
      dot.addEventListener('mouseleave', function () {
        if (selectedVariant && productImg) {
          var url = variantImages[selectedVariant.id];
          if (url) {
            productImg.src    = url;
            productImg.srcset = '';
          }
        }
        if (selectedModel) {
          applyModelConfig(selectedModel);
          applyDesignScale(selectedModel, selectedSize);
        }
      });
    });

    // Position buttons (arriba / abajo)
    document.querySelectorAll('.pv2-pos-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        textPosition = btn.dataset.pos;
        document.querySelectorAll('.pv2-pos-btn').forEach(function (b) {
          b.classList.toggle('pv2-pos-btn--active', b.dataset.pos === textPosition);
        });
        updateText();
      });
    });

    // Form submit → show modal
    if (form) {
      form.addEventListener('submit', function (e) {
        if (confirmed) return;
        e.preventDefault();
        syncCartProperties();
        showModal();
      });
    }

    // Buy now button
    var buyNowBtn = document.getElementById('pv2-buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function () {
        buyNow = true;
        syncCartProperties();
        showModal();
      });
    }

    // Confirm button
    var confirmBtn = document.getElementById('pv2-confirm-btn');
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function () {
        var isBuyNow = buyNow;
        closeModal();
        if (isBuyNow) {
          syncCartProperties();
          var props = {};
          if (propText && propText.value)      props['Texto personalizado'] = propText.value;
          if (propFont && propFont.value)      props['Tipografía']          = propFont.value;
          if (propSize && propSize.value)      props['Tamaño del diseño']   = propSize.value;
          if (propTextPos && propTextPos.value)     props['Posición del texto']   = propTextPos.value;
          if (propTextScale && propTextScale.value) props['Tamaño del texto']     = propTextScale.value;
          if (propLink && propLink.value)           props['Link del diseño']      = propLink.value;
          if (propTplVer && propTplVer.value)       props['Versión de plantilla'] = propTplVer.value;
          fetch('/cart/add.js', {
            method:  'POST',
            headers: { 'Content-Type': 'application/json' },
            body:    JSON.stringify({ id: parseInt(variantInput.value), quantity: 1, properties: props })
          }).then(function () {
            window.location.href = '/checkout';
          });
        } else {
          confirmed = true;
          if (form) {
            if (form.requestSubmit) form.requestSubmit();
            else form.submit();
          }
        }
      });
    }

    // Close modal
    var backdrop  = document.getElementById('pv2-modal-backdrop');
    var closeBtn  = document.getElementById('pv2-modal-close');
    if (backdrop) backdrop.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    if (zoomBtn)      zoomBtn.addEventListener('click', openZoom);
    if (zoomClose)    zoomClose.addEventListener('click', closeZoom);
    if (zoomBackdrop) zoomBackdrop.addEventListener('click', closeZoom);

    // Sticky add-to-cart bar (solo móvil)
    // Tres estados según la posición de los botones reales (.pv2-actions):
    //   · botones abajo del viewport  → barra abajo (personalizando)
    //   · botones visibles            → barra oculta (no duplicar el CTA)
    //   · botones ya pasados (arriba) → barra anclada arriba, bajo el header
    var stickyBar = document.getElementById('pv2-sticky-bar');
    if (stickyBar) {
      // Portal al <body>: mismo motivo que los modales — un ancestro con
      // transform/sticky rompería el position:fixed en móvil.
      if (stickyBar.parentElement !== document.body) document.body.appendChild(stickyBar);

      var stickyAddBtn = document.getElementById('pv2-sticky-add-btn');
      if (stickyAddBtn && addBtn) {
        // Reusa el flujo real: dispara el submit del form → modal de confirmación
        stickyAddBtn.addEventListener('click', function () { addBtn.click(); });
      }
      var stickyBuyBtn = document.getElementById('pv2-sticky-buynow-btn');
      var realBuyBtn   = document.getElementById('pv2-buy-now-btn');
      if (stickyBuyBtn && realBuyBtn) {
        // Reusa el flujo real de "Comprar ahora" (modal → checkout)
        stickyBuyBtn.addEventListener('click', function () { realBuyBtn.click(); });
      }

      var stickyActionsEl = document.querySelector('.pv2-actions');
      if (stickyActionsEl) {
        var stickyHeaderEl = document.querySelector('.section-header, #shopify-section-header, sticky-header, .site-header');
        var stickyGetHeaderH = function () {
          // Borde inferior VISIBLE del header (0 si está oculto o ya scrolleó):
          // la barra se ancla justo debajo, siguiendo incluso su animación.
          if (!stickyHeaderEl) return 0;
          return Math.max(0, stickyHeaderEl.getBoundingClientRect().bottom);
        };
        // Un solo botón que se desplaza: la barra nunca desaparece. Su posición
        // en pantalla es la de los botones reales (ocultos en móvil: la barra
        // ES el botón), clampada entre el borde inferior y el header:
        //   · botones abajo del fold  → barra fija al borde inferior (estrecha)
        //   · botones en pantalla     → barra viaja con el scroll y se expande
        //   · botones ya pasados      → barra anclada bajo el header (ancho completo)
        var stickyMediaEl = document.querySelector('.pv2-media');
        var stickyMediaTy = 0;
        var stickyWaFloat = document.getElementById('pv2-wa-float');
        if (stickyWaFloat && stickyWaFloat.parentElement !== document.body) {
          document.body.appendChild(stickyWaFloat); // mismo portal que la tarjeta
        }
        var stickyUpdate = function () {
          var rect    = stickyActionsEl.getBoundingClientRect();
          var barH    = stickyBar.offsetHeight || 66;
          var vh      = window.innerHeight;
          var headerB = stickyGetHeaderH();
          var isMobile = window.matchMedia('(max-width: 749px)').matches;

          if (isMobile) {
            // ── Móvil: tarjeta que viaja ligada al scroll ──
            stickyBar.classList.remove('pv2-sticky-bar--desktop');
            // La tarjeta es más alta que los botones reales que reemplaza:
            // reserva su alto en .pv2-actions para que el contenido que sigue
            // (specs) no quede tapado cuando la tarjeta viaja alineada ahí.
            var reserveH = (barH + 8) + 'px';
            if (stickyActionsEl.style.minHeight !== reserveH) stickyActionsEl.style.minHeight = reserveH;
            var minY = headerB + 8;              // flota 8px bajo el header
            var maxY = vh - barH - 16;           // flota 16px sobre el borde inferior
            var y = Math.max(minY, Math.min(rect.top, maxY));
            stickyBar.style.transform = 'translateY(' + y + 'px)';

            // Tarjeta despegada del fondo → el WhatsApp de la tarjeta se colapsa
            // (Comprar ahora se estira) y la burbuja flotante aparece en la esquina
            var lifted = y < maxY - 2;
            stickyBar.classList.toggle('pv2-sticky-bar--lifted', lifted);
            if (stickyWaFloat) stickyWaFloat.classList.toggle('pv2-wa-float--on', lifted);

            // La tarjeta es lo último que queda arriba: al subir "empuja" el
            // preview sticky fuera de la pantalla — el borde inferior de la
            // imagen viaja pegado al borde superior de la tarjeta.
            // SOLO cuando la tarjeta ya despegó: en reposo (fondo de pantalla)
            // el preview grande del tope de la página puede quedar por debajo
            // de la tarjeta y NO debe empujarse (taparía el título).
            if (stickyMediaEl) {
              if (lifted) {
                var mBottomNatural = stickyMediaEl.getBoundingClientRect().bottom - stickyMediaTy;
                var mTy = Math.min(0, y - mBottomNatural);
                stickyMediaTy = mTy;
                stickyMediaEl.style.transform = mTy ? 'translateY(' + mTy + 'px)' : '';
              } else if (stickyMediaTy) {
                stickyMediaTy = 0;
                stickyMediaEl.style.transform = '';
              }
            }
          } else {
            // ── Escritorio: barra superior que se desliza desde atrás del
            // header cuando los botones de compra reales salen de la vista ──
            stickyBar.classList.add('pv2-sticky-bar--desktop');
            stickyBar.classList.remove('pv2-sticky-bar--lifted');
            if (stickyActionsEl.style.minHeight) stickyActionsEl.style.minHeight = '';
            var show = rect.bottom < headerB + 4;
            stickyBar.style.transform = 'translateY(' + (show ? headerB : -(barH + 40)) + 'px)';
            if (stickyWaFloat) stickyWaFloat.classList.remove('pv2-wa-float--on');
            if (stickyMediaEl && stickyMediaTy) {
              stickyMediaTy = 0;
              stickyMediaEl.style.transform = '';
            }
          }
        };
        var stickyTicking = false;
        var stickyOnScroll = function () {
          if (stickyTicking) return;
          stickyTicking = true;
          requestAnimationFrame(function () {
            stickyTicking = false;
            stickyUpdate();
          });
        };
        window.addEventListener('scroll', stickyOnScroll, { passive: true });
        window.addEventListener('resize', stickyOnScroll, { passive: true });
        stickyUpdate();
      }
    }

    // Share button
    var shareBtn = document.getElementById('pv2-share-btn');
    if (shareBtn) shareBtn.addEventListener('click', handleShare);
    // Compartir circular (móvil, junto a la lupa)
    var shareFab = document.getElementById('pv2-share-fab');
    if (shareFab) shareFab.addEventListener('click', handleShare);

    // Download image buttons (optional, controlled by section setting)
    var closeupBtn = document.getElementById('pv2-copy-img-btn');
    if (closeupBtn) closeupBtn.addEventListener('click', handleDownloadCloseup);
    var fullBtn = document.getElementById('pv2-full-img-btn');
    if (fullBtn) fullBtn.addEventListener('click', handleDownloadFull);

    // Restore state from URL params (for shared links)
    (function () {
      var p = new URLSearchParams(window.location.search);
      var pVariant   = p.get('v');
      var pModel     = p.get('model');
      var pColor     = p.get('color');
      var pScale     = p.get('scale');
      var pText      = p.get('text');
      var pFont      = p.get('font');
      var pTextpos   = p.get('textpos');
      var pTextscale = p.get('textscale');

      // Priorizar variant_id: si existe y la variante está disponible, derivar
      // model y color de ahí. Sólo si no se encuentra, caer al fallback por nombre.
      var variantApplied = false;
      if (pVariant) {
        var vid = parseInt(pVariant, 10);
        if (!isNaN(vid)) {
          var match = variants.filter(function (v) { return v.id === vid; })[0];
          if (match) {
            var vModel = getOption(match, modelOptionIdx);
            var vColor = getOption(match, colorOptionIdx);
            if (vModel) selectModel(vModel);
            if (vColor) selectColor(vColor);
            variantApplied = true;
          }
        }
      }
      if (!variantApplied) {
        if (pModel) selectModel(pModel);
        if (pColor) selectColor(pColor);
      }

      if (pScale) {
        var s = parseInt(pScale, 10);
        if (!isNaN(s)) { designScalePct = Math.max(50, Math.min(100, s)); applyDesignScale(); updateLayout(); }
      }
      if (pFont) {
        var fontBtn = document.querySelector('.pv2-font-opt[data-font="' + pFont + '"]');
        if (fontBtn) fontBtn.click();
      }
      if (pTextpos) {
        var posBtn = document.querySelector('.pv2-pos-btn[data-pos="' + pTextpos + '"]');
        if (posBtn) posBtn.click();
      }
      if (pTextscale) {
        var ts = parseInt(pTextscale, 10);
        if (!isNaN(ts)) textScale = Math.max(30, Math.min(300, ts));
      }
      if (pText && textInput) {
        // URLSearchParams.get() ya hace el decode; un decode adicional fallaría con caracteres '%' literales.
        textInput.value = pText;
        updateText();
      }
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
    if (productImg) {
      productImg.addEventListener('load', refreshZone);
    }
    window.addEventListener('resize', refreshZone);
  }
})();
